<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import StoresPhotoUploader from './StoresPhotoUploader';
import StoresForm from './StoresForm';
import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Stores',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, StoresForm, StoresPhotoUploader, CommunicationsTable },
  data() {
    return {
      title: 'Stores',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Stores', to: '/stores', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      cart_item: {
        id: '',
        title: '',
        description: '',
        price: '',
        quantity: '1',
        size: '',
        color: '',
        thumbnail: '',
      },

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Stores\\Models\\Store',
      },

    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/stores/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          if(!res.data.data[0].body) { res.data.data[0].body = ''; }
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.title;
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/stores');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    update_store() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/stores/update', this.item).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_store() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this store?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/stores/delete/'+this.item.id, this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$router.push('/stores');
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Preview</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Images</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>

    <div v-if="item.id">

      <div class="row mt-4 set-sm-375">
        <div class="col-sm-4">

          <!--
          id
          status
          user_id
          website
          view_count
          title
          description
          price
          stock
          max_per_order
          sizes
          colors
          thumbnail
          PhotosCount
          images
          created_at
          updated_at
          deleted_at
          -->
          <div class="card-box">
            <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> About :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="border-0"><label>Live :</label></th><td class="border-0 small"><div v-if="item.status" class="alert alert-success small mb-0 px-2 py-1">Yes</div><div v-else class="alert alert-danger small mb-0 px-2 py-1">No</div></td></tr>
                  <tr><th><label>Website :</label></th><td class="small">{{item.website}}</td></tr>
                  <tr><th><label>Views :</label></th><td class="small">{{item.view_count}}</td></tr>
                  <tr><th><label>Price :</label></th><td class="small">{{formatPrice(item.price)}}</td></tr>
                  <tr><th><label>Stock Remaining :</label></th><td class="small">{{item.stock < 0  ? 'Unlimited' : item.stock}}</td></tr>
                  <tr><th><label>Max per order :</label></th><td class="small">{{item.max_per_order < 0  ? 'Unlimited' : item.max_per_order}}</td></tr>
                  <tr><th><label>Updated on :</label></th><td class="small" v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td></tr>
                  <tr><th><label>Created on :</label></th><td class="small" v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card-box p-0">
            <div class="_p-t-100p position-relative _c-pointer" :style="'background-image: url(' + formatImage('/fm/revinre-store/clip art/trasnparent-b1g.png') + ')'">
              <div class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0 text-center p-2">
                <img class="_h-m-100p _w-m-100p" :src="formatImage(item.thumbnail)" >
              </div>
            </div>
            <div class="card-body border-top border-light">
              <div class="float-right">
                <div class="text-black font-weight-bold">{{ formatPrice(item.price) }}</div>
              </div>
              <div class="mb-2">
                <span v-for="(color, color_i) in item.colors" :key="color_i" class="p-2 mr-2 d-inline-block rounded-circle" :style="'background-color:'+color"></span>
              </div>
              <div class="font-weight-bold text-black mb-2">{{ item.title }}</div>
              <p class="small mb-2 overflow-hidden _h-m-65" v-html="item.description"></p>
              <a class="btn btn-block btn-revinre">View details <Icon icon="ri:arrow-right-fill" class="m-0" /></a>
            </div>
          </div>

          <button type="button" class="btn btn-block btn-outline-danger" @click="delete_store" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Product</button>

        </div>
        <div class="col-sm-8">

          <div v-show="tabIndex == 0">
            <div class="card-box position-relative">
              <div class="row">
                <div class="col-sm-5">
                  <w-image-slider v-if="item.images && item.images.length" :images="item.images"></w-image-slider>
                </div>
                <div class="col-sm-6 offset-sm-1">
                  <div class="font-weight-bold _f-s-30">{{ item.title }}</div>
                  <div class="font-weight-bold _f-s-25">{{ formatPrice(item.price) }}</div>
                  <hr class="my-4 border-light">
                  <div class="mb-3">
                    <label class="_f-s-15 mb-2">Color:</label>
                    <div class="mb-2">
                      <span v-for="(color, color_i) in item.colors" :key="color_i" class="p-2 mr-2 d-inline-block rounded-circle" :style="'background-color:'+color"></span>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="_f-s-15 mb-2">Size:</label>
                    <w-field SimpleDataType="String List, Single" :Options="item.sizes" v-model="cart_item.size" placeholder="Select..."></w-field>
                  </div>
                  <div class="mb-3">
                    <label class="_f-s-15 mb-2">Quantity:</label>
                    <input type="number" class="form-control" min="0" step="any" v-model="cart_item.quantity">
                  </div>
                  <button class="btn btn-revinre"><Icon icon="ri:shopping-basket-2-line" class="m-0" /> Add to cart</button>
                </div>
              </div>
              <hr class="my-4 border-light">
              <div class="_f-s-25 font-weight-bold">Product Description:</div>
              <p v-html="item.description"></p>
            </div>
          </div>

          <div v-show="tabIndex == 1">
            <div class="card-box">
              <b-form @submit.prevent="update_store">
                <StoresForm :item="item"></StoresForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>

          <div v-show="tabIndex == 2">
            <div class="card-box position-relative">
              <StoresPhotoUploader :item="item"></StoresPhotoUploader>
            </div>
          </div>

          <div v-show="tabIndex == 3">
            <div class="">
              <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
            </div>
          </div>

        </div>
      </div>

    </div>
  </Layout>
</template>
